import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Login from "./components/login";
import AdminMain from "./components/Admin/main";
import SuperAdminMain from "./components/SuperAdmin/main";
import Stream from "./components/stream";
import LandingPage from "./components/landingPage";
import AdminRoute from "./helpers/adminRoute";
import SuperAdminRoute from "./helpers/superAdminRoute";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/admin/login" component={Login}></Route>
        <Route exact path="/" component={LandingPage}></Route>
        <AdminRoute path="/admin" component={AdminMain}></AdminRoute>
        <SuperAdminRoute
          path="/superadmin"
          component={SuperAdminMain}
        ></SuperAdminRoute>
        <Route exact path="/:id" component={Stream}></Route>
      </Switch>
    </Router>
  );
}

export default App;
